<div class="container" *ngIf="hasValue" >
  <mat-table [dataSource]="dataSource.data"  class="table-list" multiTemplateDataRows>
    
    <ng-container matColumnDef="idPfac" class="table-list__column">
      <mat-header-cell *matHeaderCellDef [ngClass]="'header-name'"> ID </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'column-name'"> {{element.id}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="cnpjPfac" class="table-list__column">
      <mat-header-cell *matHeaderCellDef [ngClass]="'header-name'"> CNPJ </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'column-name'"> {{element.cnpj |cpfCnpj}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="namePfac" class="table-list__column">
      <mat-header-cell *matHeaderCellDef [ngClass]="'header-name'"> Nome do Cliente </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'column-name'"> {{element.name}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdAtPfac" class="table-list__column">
      <mat-header-cell *matHeaderCellDef [ngClass]="'header-name'"> Data da Inclusão </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'column-name'"> {{element.createAt}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>

    <ng-container matColumnDef="options_edit">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
       <mat-cell *matCellDef="let element" class="options">

        <fa-icon class="fd-icon" matTooltip="Histórico" icon="history"
            class="edit-link" (click)="showAudit(element)"></fa-icon>
              
        <ng-container *ngIf="element.active">
          <fa-icon class="edit-link" matTooltip="Desabilitar" icon="toggle-on"
            class="edit-link" (click)="disable(element)"></fa-icon>
        </ng-container>

        <ng-container *ngIf="!element.active">
          <fa-icon class="edit-link" matTooltip="Habilitar" icon="toggle-off"
          class="edit-link" (click)="enable(element)"></fa-icon>
        </ng-container>

        <fa-icon class="fd-icon" matTooltip="Editar PFAC" icon="edit"
          class="edit-link" (click)="edit(element)"></fa-icon>
      </mat-cell> 
    </ng-container>
  </mat-table>
  <mat-paginator #paginator
  [pageSizeOptions]="[defaultSizeItems,defaultSizeItems*2,defaultSizeItems*3,defaultSizeItems*4,defaultSizeItems*5,defaultSizeItems*6,defaultSizeItems*7,defaultSizeItems*8,defaultSizeItems*9,defaultSizeItems*10]"
  (page)="change($event)" [length]="totalItens" [pageIndex]="page"></mat-paginator>
</div> 

<h5 *ngIf="!hasValue">Nenhum registro foi encontrado</h5>